export default "__VITE_ASSET__4Zol9yAR__"